import React from 'react';
import ServicePage from '../../components/ServicePage';

const LocalMoving = () => (
  <ServicePage
    seoTitle="Local Moving in Washington | Navy Seals Moving"
    seoDescription="Local moves across the Puget Sound area by the same professional crews that handle our long-distance moves. Accurate estimates, careful packing, and our own trucks and equipment."
    headerTitle="Local Moving"
    introTitle="Local Moves, Long-Distance Standards"
    intro={[
      "A local move deserves the same care as a cross-country one. Whether you're moving across town, to the next city, or anywhere within Washington, you get the same professional crews, the same trucks, and the same standards that earned us a perfect 5.0 on Google.",
      "We are a family-owned company based in Puyallup, serving the Puget Sound area for over 20 years. Your move is handled start to finish by our own team: the crew that packs your home loads our truck and places everything exactly where you want it in the new one.",
      "Every local move starts with an accurate estimate, by video call or an in-person visit, so you know what to expect before moving day. And if your new home isn't ready yet, our secure, climate-controlled warehouse bridges the gap."
    ]}
    featuresTitle="What You Can Expect"
    features={[
      {
        icon: 'icon_house',
        title: 'An Accurate Estimate First',
        text: 'By video call or an in-person visit: we look at what is actually moving, so your quote reflects your home, not a guess over the phone.'
      },
      {
        icon: 'icon_group',
        title: 'Professional Local Crews',
        text: 'The same trained, full-time crews that handle our long-distance moves, working carefully and efficiently in your neighborhood.'
      },
      {
        icon: 'icon_easel',
        title: 'Packing If You Want It',
        text: 'Full packing with premium materials, fragile-items-only, or you pack and we move. Your choice, priced upfront.'
      },
      {
        icon: 'icon_datareport',
        title: 'Storage Nearby',
        text: 'Our own secure, climate-controlled warehouse in Puyallup, ready if your dates do not line up.'
      }
    ]}
  />
);

export default LocalMoving;
